import useCubeItems, { PageType } from '../../hooks/useCubeItems/useCubeItems'
import CubePageTemplate from '../../CubePageTemplate/CubePageTemplate'

type Props = {
  showBierdeckelPopup?: boolean
}

const Topic: React.FC<Props> = ({ showBierdeckelPopup }) => {
  const items = useCubeItems(PageType.PARTEITAG)

  if (showBierdeckelPopup) {
    return <CubePageTemplate items={items} showBierdeckelPopup isTopic />
  } else {
    return <CubePageTemplate items={items} showVideoPopup isTopic />
  }
}

export default Topic
